const state = {
  showNotification: false,
  customNotification: null,
  isExpire: false,
  notiInfo: {
    isCustomMsg: false,
    msgHTML: '',
    btnName: '확인',
    btnEvent: () => {}
  }
};

const getters = {
  showNotification: (state) => {
    return state.showNotification;
  },
  customNotification: (state) => {
    return state.customNotification;
  },
  isExpire: (state) => {
    return state.isExpire;
  },
  notiInfo: (state) => {
    return state.notiInfo;
  }
};

const mutations = {
  setShowNotification(state, value) {
    state.showNotification = value;
  },
  setCustomNotification(state, value) {
    state.customNotification = value;
  },
  setIsExpire(state, value) {
    state.isExpire = value;
  },
  setNotiInfo(state, value) {
    state.notiInfo = value;
  }
};

export default {
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/notification/index.js